import React from "react";
import AppVersionBloc from "src/hybrid/AppVersionBloc";
import { useBloc } from "src/state/state";
import {
  DebugBadge,
  DebugButton,
  DebugButtonRow,
  DebugDivider,
  DebugKeyValue
} from "./debug.styles";

const DebugVersion = () => {
  const [
    { current, latest, local = { bundles: [] }, pluginDetails },
    { reset, setVersion }
  ] = useBloc(AppVersionBloc);

  const hasUpdate =
    latest?.version && latest?.version !== current?.bundle.version;

  return (
    <div>
      <DebugKeyValue>
        <span className="key">Active Bundle</span>
        <span className="value">
          <DebugBadge variant="success">
            {current?.bundle.version || "unknown"}
          </DebugBadge>
        </span>
      </DebugKeyValue>
      <DebugKeyValue>
        <span className="key">Latest Available</span>
        <span className="value">
          {latest?.version ? (
            <DebugBadge variant={hasUpdate ? "warning" : "success"}>
              {latest?.version}
              {hasUpdate && " (update available)"}
            </DebugBadge>
          ) : (
            "—"
          )}
        </span>
      </DebugKeyValue>

      {pluginDetails != null && (
        <details style={{ marginTop: "0.75rem" }}>
          <summary
            style={{ cursor: "pointer", fontSize: "12px", color: "#666" }}
          >
            Capacitor Updater Info
          </summary>
          <pre
            style={{
              fontSize: "10px",
              background: "#f5f5f7",
              padding: "0.5rem",
              borderRadius: "4px",
              overflow: "auto",
              marginTop: "0.5rem"
            }}
          >
            {JSON.stringify(pluginDetails, null, 2)}
          </pre>
        </details>
      )}

      {local.bundles.length > 0 && (
        <>
          <DebugDivider />
          <h4
            style={{ fontSize: "13px", margin: "0 0 0.75rem", fontWeight: 600 }}
          >
            Downloaded Bundles
          </h4>
          {local.bundles.map((v) => (
            <div
              key={v.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0.5rem 0",
                borderBottom: "1px solid #e0e0e0"
              }}
            >
              <div>
                <span style={{ fontWeight: 500, fontSize: "13px" }}>
                  {v.version}
                </span>
                <span
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "11px",
                    color: "#666"
                  }}
                >
                  {v.status}
                </span>
                {v.version === current?.bundle.version && (
                  <DebugBadge
                    variant="success"
                    style={{ marginLeft: "0.5rem" }}
                  >
                    Active
                  </DebugBadge>
                )}
              </div>
              {v.version !== current?.bundle.version && (
                <DebugButton
                  className="small"
                  onClick={() => void setVersion(v)}
                >
                  Switch
                </DebugButton>
              )}
            </div>
          ))}
        </>
      )}

      {current?.bundle.version !== "builtin" && (
        <>
          <DebugDivider />
          <DebugButtonRow>
            <DebugButton className="danger" onClick={reset}>
              Reset to Factory Bundle
            </DebugButton>
          </DebugButtonRow>
        </>
      )}
    </div>
  );
};

export default DebugVersion;
